import React from "react";
import deleteAccountLogo from "../../assets/images/deleteAccountLogo.png";
const DeleteAccountHeader = () => {
  return (
    <div class="header_v2 boxWhite">
      <img src={deleteAccountLogo} alt="pup" />
      <span>Delete account</span>
    </div>
  );
};

export default DeleteAccountHeader;
